/* Supp City: blogartikel — direct in winkelwagen, tabbladen met producten en actieve kop in de inhoudsopgave */
(function () {
  if (window.scBlog) return;
  window.scBlog = true;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Prijs volgt de gekozen smaak
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.sc-bprod__select');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var price = sel.closest('.sc-bprod').querySelector('[data-sc-price]');
    if (opt && price && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  // Verborgen regel-eigenschappen (_bron, _artikel) gaan mee naar de order, zodat de kennisbank-omzet meetbaar is
  function props(form) {
    var out = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (i) { out[i.name.slice(11, -1)] = i.value; });
    return out;
  }

  // Bezoek aan een artikel als verborgen winkelwagen-attribuut, eenmaal per artikel per sessie
  function visit() {
    var key = 'sc-kb:' + location.pathname;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
    fetch(base + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _kennisbank_artikel: location.pathname.split('/').pop() } })
    }).catch(function () {});
  }

  // Toevoegen zonder de pagina te verlaten; zonder JavaScript post het formulier gewoon naar /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sc-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.sc-bprod__btn');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Bezig…';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1, properties: props(form) }],
        sections: 'cart-icon-bubble'
      })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) throw d;
      var html = d.sections && d.sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (html && bubble) {
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      btn.classList.add('is-added');
      btn.textContent = 'Toegevoegd ✓';
      document.dispatchEvent(new CustomEvent('sc:cart-updated'));
      setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = label; }, 2500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = err && err.status === 422 ? 'Niet op voorraad' : 'Probeer opnieuw';
      setTimeout(function () { btn.textContent = label; }, 3000);
    });
  });

  // Tabbladen: zonder JavaScript staan alle collecties onder elkaar
  function tabs() {
    document.querySelectorAll('[data-sc-tabs]').forEach(function (box) {
      var list = box.querySelectorAll('[role="tab"]');
      if (!list.length) return;
      var show = function (tab, focus) {
        list.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
        });
        if (focus) tab.focus();
      };
      list.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (n) { e.preventDefault(); show(list[(i + n + list.length) % list.length], true); }
        });
      });
      show(list[0]);
      box.classList.add('is-ready');
    });
  }

  // Inhoudsopgave: markeer de kop waar je nu bent
  function toc() {
    var nav = document.querySelector('[data-sc-toc]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = {};
    nav.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var current;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        if (current) current.classList.remove('is-active');
        current = links[en.target.id];
        if (current) current.classList.add('is-active');
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    Object.keys(links).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
  }

  function start() { tabs(); toc(); visit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
